import { useState } from "react";
import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { fmtCurrency } from "@/lib/format";
import { Handshake, ChatCircleDots, CheckCircle } from "@phosphor-icons/react";

export default function BusinessDevelopment() {
  const { lists, nameMap } = useLookups();
  const [rows, setRows] = useState([]);

  const pipeline = rows.reduce((s, r) => s + Number(r.expected_value || 0), 0);
  const inDiscussion = rows.filter((r) => r.status === "In Discussion").length;
  const active = rows.filter((r) => r.status === "Active" || r.status === "Agreement Signed").length;

  const cards = [
    { label: "Total Pipeline Value", value: fmtCurrency(pipeline), icon: Handshake, color: "text-navy", bg: "bg-gold/10" },
    { label: "In Discussion", value: inDiscussion, icon: ChatCircleDots, color: "text-gold", bg: "bg-gold/10" },
    { label: "Active / Signed", value: active, icon: CheckCircle, color: "text-emerald", bg: "bg-emerald/10" },
  ];

  const header = (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {cards.map((c) => {
        const Icon = c.icon;
        return (
          <div key={c.label} className="rounded-lg bg-white border border-slate-200 p-4 flex items-center gap-3">
            <div className={`h-11 w-11 rounded-lg ${c.bg} flex items-center justify-center`}><Icon size={22} weight="fill" className={c.color} /></div>
            <div>
              <div className={`font-heading text-2xl font-extrabold ${c.color}`}>{c.value}</div>
              <div className="text-xs text-slate">{c.label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div data-testid="bd-page">
      <CrudTable resource="bd" config={MODULES.bd} lists={lists} nameMap={nameMap} onData={setRows} extraHeader={header} />
    </div>
  );
}
